<router>
{
    name: 'paMonitor',
}
</router>
<template lang="pug">
v-container
    PortalpaMonitor
</template>
<script>

import PortalpaMonitor from '@/components/portal/paMonitor';

export default {
    meta: {
        // role: 'portalcontact'
    },
    components: {
        PortalpaMonitor
    },
    data () {
        return {

        };
    },
    methods: {

    },
    computed: {
    },
    mounted () {
        window.portalpaMonitor = this;
    }
};
</script>

<style scoped>
</style>
